module.exports = __webpack_public_path__ + "img/Internet (5).07573a95.png";